import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { Calendar } from '@cocoonspace/ui/components/calendar'
import { fr } from 'date-fns/locale/fr'

import { useBookingVisitStore } from '../space-visit.store'

export const DayStep = () => {
	const day = useBookingVisitStore.use.day()
	const setDay = useBookingVisitStore.use.setDay()
	const setStep = useBookingVisitStore.use.setStep()

	return (
		<Calendar
			className='mx-auto'
			classNames={{
				button:
					'!text-xs rounded-full h-[42px] w-[42px] flex items-center justify-center cursor-pointer',
				cell: '!h-[42px] w-[42px]',
				day_outside: 'opacity-50',
				head_cell: 'text-xs h-[42px] !w-[42px] font-normal opacity-50',
				months: 'flex flex-row gap-4',
			}}
			fixedWeeks
			fromDate={dateTimeUtils().toDate()}
			locale={fr}
			mode='single'
			onSelect={(d) => {
				setDay(dateTimeUtils(d).format('YYYY-MM-DD'))
				setStep('startTime')
			}}
			selected={new Date(day)}
			showOutsideDays
		/>
	)
}
